import { render, staticRenderFns } from "./MovementsMainPage.vue?vue&type=template&id=743337f4&"
import script from "./MovementsMainPage.vue?vue&type=script&lang=js&"
export * from "./MovementsMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports